"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const core_ui_1 = require("@sierralabs/core-ui");
const FieldPicker_1 = __importDefault(require("../pickers/FieldPicker"));
const EditableFieldSection = props => {
    var _a, _b;
    const { shape, workflowDto, onChange } = props;
    const allowedFields = ((_b = (_a = shape.data) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.allowedFields) || [];
    return (react_1.default.createElement(core_ui_1.ConfigCard, null,
        react_1.default.createElement(core_ui_1.ConfigHeader, null, "Editable Fields"),
        react_1.default.createElement(core_ui_1.ConfigContent, null,
            react_1.default.createElement(core_1.FormControl, { className: 'form-control' },
                react_1.default.createElement(FieldPicker_1.default, { value: allowedFields, taskTypeId: workflowDto.taskTypeId, onChange: fields => onChange === null || onChange === void 0 ? void 0 : onChange(fields.map(field => field.value)) }),
                react_1.default.createElement(core_1.FormHelperText, { className: 'helper-text' }, "Checked fields will be editable in this State.")))));
};
exports.default = EditableFieldSection;
//# sourceMappingURL=EditableFieldSection.js.map